import * as React from 'react';

import FileVideo32 from './FileVideo32';

export const fileVideo32 = () => <FileVideo32 />;

export default {
    title: 'Icon/Content/FileVideo32',
    component: FileVideo32,
    parameters: {
        notes: "`import FileVideo32 from 'box-ui-elements/es/icon/content/FileVideo32';`",
    },
};
